export function notHidden(selector) {
    return selector.split(",").map((selectorPart) => `${selectorPart.trim()}:not([hidden])`).join();
}
